import { isApiValidationError, isErrorsList } from "../guards";
var getErrorsListFromError = function (e) {
    var _a, _b, _c;
    if (!isApiValidationError(e) || !e.response || !((_a = e.response) === null || _a === void 0 ? void 0 : _a.data) || !((_c = (_b = e.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.errors)) {
        return { 'unknown': ['Невідома помилка'] };
    }
    var errors = e.response.data.errors;
    if (!isErrorsList(errors)) {
        return { 'unknown': ['Невідома помилка'] };
    }
    return errors;
};
export default getErrorsListFromError;
//# sourceMappingURL=getErrorsListFromError.js.map